import { apiClass } from '../../classes/api.class'
import { ENDPOINTS } from '../../const/endpoints.const'
import i18n from '../../i18n/index'
import { ToolsClass } from '../../classes/tools.class'
import { COOKIES } from '../../const/cookies.const'
import { PiwikClass } from '../../classes/piwik.class'

const expireDays = 365

const state = {
  apiVersions: null,
  currentVersion: null,
  version: null,
  lang: null,
  isLoading: false,
  device: null,
  navigation: {},
  currentNavigation: [],
  section: null,
  mdFilePath: null,
  isDownloadSectionActive: false,
  isDocsSectionActive: false,
  isFaqSectionActive: false,
  isChangelogSectionActive: false
}

const mutations = {
  setDocsSectionActive (state) {
    state.isDocsSectionActive = true
    state.isDownloadSectionActive = false
    state.isFaqSectionActive = false
    state.isChangelogSectionActive = false
    PiwikClass.sendDocsClickedEvent(state.device)
  },
  setDocsSectionInactive (state) {
    state.isDocsSectionActive = false
  },
  setDownloadSectionActive (state) {
    state.isDownloadSectionActive = true
    state.isDocsSectionActive = false
    state.isFaqSectionActive = false
    state.isChangelogSectionActive = false
    PiwikClass.sendDownloadClickedEvent(state.device)
  },
  setDownloadSectionInactive (state) {
    state.isDownloadSectionActive = false
  },
  setFaqSectionActive (state) {
    state.isFaqSectionActive = true
    state.isDocsSectionActive = false
    state.isDownloadSectionActive = false
    state.isChangelogSectionActive = false
    PiwikClass.sendFaqClickedEvent(state.device)
  },
  setChangelogSectionActive (state) {
    state.isFaqSectionActive = false
    state.isDocsSectionActive = false
    state.isDownloadSectionActive = false
    state.isChangelogSectionActive = true
    PiwikClass.sendChangelogClickedEvent(state.device)
  },
  setChangelogSectionInactive (state) {
    state.isChangelogSectionActive = false
  },
  setSdkApiVersionsData (state, data) {
    state.apiVersions = data
  },
  setSdkCurrentVersion (state, data) {
    state.currentVersion = data
  },
  setSdkVersion (state, value) {
    state.version = value
    ToolsClass.setCookie(COOKIES.version, value, expireDays, true)
    PiwikClass.sendVersionEvent(value, state.device)
  },
  setSdkLanguage (state, value) {
    i18n.locale = value
    state.lang = value
    if (state.navigation[state.device] && state.navigation[state.device][value]) {
      state.currentNavigation = state.navigation[state.device][value]
    }
    ToolsClass.setCookie(COOKIES.language, value, expireDays)
    window.dispatchEvent(new CustomEvent('langChange', { detail: value }))
  },
  setSdkLoadingFlag (state, value) {
    state.isLoading = value
  },
  setSdkCurrentDevice (state, value) {
    state.device = value
    if (state.navigation[value] && state.navigation[value][state.lang]) {
      state.currentNavigation = state.navigation[value][state.lang]
    }
  },
  setSdkMdFilePath (state, data) {
    state.mdFilePath = data
  },
  setSdkNavigationArray (state, data) {
    state.navigation = data
    if (data[state.device] && data[state.device][state.lang]) {
      state.currentNavigation = data[state.device][state.lang]
    }
  },
  setSdkCurrentSection (state, data) {
    state.section = data.toString()
  }
}

const actions = {
  getSdkApiVersionsList (context, data) {
    context.commit('setSdkLoadingFlag', true)

    return apiClass.get(ENDPOINTS.apiVersions, data)
      .then(response => {
        let responseData = response.body
        context.commit('setSdkApiVersionsData', responseData)

        let defaultVersion = responseData.find(item => item.default)
        const cookieVersion = ToolsClass.getCookie(COOKIES.version)
        const cookieLang = ToolsClass.getCookie(COOKIES.language)

        if (cookieVersion && responseData.find(item => item.version === cookieVersion)) {
          defaultVersion = responseData.find(item => item.version === cookieVersion)
        }
        context.commit('setSdkCurrentVersion', defaultVersion)
        context.commit('setSdkVersion', defaultVersion.version)

        if (cookieLang && defaultVersion.lang.find(language => language.lang === cookieLang)) {
          context.commit('setSdkLanguage', cookieLang)
        } else {
          context.commit('setSdkLanguage', defaultVersion.lang.find(lang => lang.default).lang)
        }
        return Promise.resolve()
      }, error => {
        return Promise.reject(error)
      })
      .finally(() => {
        context.commit('setSdkLoadingFlag', false)
      })
  },
  changeSdkVersion (context, value) {
    let current = context.state.apiVersions.find(item => item.version === value)
    context.commit('setSdkCurrentVersion', current)
    context.commit('setSdkVersion', current.version)
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
